import * as yup from 'yup'

export class SettingsMissingOhioTitleAlertDto {
  missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio?: number = undefined
}

export const missingOhioTitleAlertValidationSchema = yup.object<SettingsMissingOhioTitleAlertDto>({
  missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio: yup
    .number()
    .min(0, 'Missing Ohio Title Alert cannot be less then 0 days.')
    .max(999_999_999_999_999, 'Missing Ohio Title Alert cannot be more than 999,999,999,999,999 days.')
    .required('Missing Ohio Title Alert is required.')
})
